<template>
	<Modal @close="$emit('close')" :draggable="false">
		<!-- <template slot="title">Sales Order History Items</template> -->
		<template slot="title">Ship To Address Management</template>
		<template slot="body">
			<!-- <div class="popup_body"> -->
			<div style="width:1250px; height:800px;">
				<table class="list_tbl">
					<thead>
						<tr>
							<th width="250px;">Company Name</th>
							<th>Address</th>
							<th width="100px;">Address 2</th>
							<th width="150px;">City</th>
							<th width="80px;">State</th>
							<th width="70px;">Zipcode</th>
							<th width="100px;">Country</th>
							<th width="150px;">Telephone</th>
							<th style="text-align:center;width:30px;;">Active</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(addr, index) in filtered_addresses" v-bind:key="index">
							<td class="al_left">{{ addr.ship_to_name }}</td>
							<td class="al_left">{{ addr.address_detail }}</td>
							<td class="al_left">{{ addr.address_detail2 }}</td>
							<td class="al_left">{{ addr.address_city }}</td>
							<td class="al_left">{{ addr.address_state }}</td>
							<td class="al_left">{{ addr.address_zipcode }}</td>
							<td class="al_left">{{ addr.address_country }}</td>
							<td class="al_left">{{ addr.telephone }}</td>
							<td class="al_center"><input type="checkbox" v-model="addr.active" @click="notify()" /></td>
						</tr>
					</tbody>
				</table>

				<div class="popup_bottom">
					<label for="active_only" style="float:left;"> <input type="checkbox" id="active_only" v-model="active_only" />Active Only</label>
					<a v-if="modifiable" href="javascript:;" @click="applyAddrManagement()" class="search_bt mgr_15">Save & Close</a>
					<a href="javascript:;" @click="$emit('close')" class="gray_bt">Cancel</a>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/common/Modal';
import { apiSelectShipToAddressHistory, apiActivateShipToAddress } from '@/api/sales/invoice.js';
export default {
	data: () => ({
		prev_ship_to_address_list_for_update: [],
		active_only: true,
	}),
	components: {
		Modal,
	},
	props: {
		prev_ship_to_address_list: {
			type: Array,
			default: null,
		},
		partner_code: {
			// ship_to
			type: String,
			default: null,
		},
		modifiable: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		filtered_addresses: function() {
			if (this.active_only) return this.prev_ship_to_address_list_for_update.filter(s => s.active);
			else return this.prev_ship_to_address_list_for_update;
		},
	},
	methods: {
		async loadShipToAddressHistory() {
			if (!this.partner_code) return;

			const { data } = await apiSelectShipToAddressHistory({
				ship_to_code: this.partner_code,
			});

			this.prev_ship_to_address_list_for_update = data.shipToAddressList;
		},
		async applyAddrManagement() {
			const { data } = await apiActivateShipToAddress({
				ship_to_code: this.partner_code,
				addresses: this.prev_ship_to_address_list_for_update,
			});
			if (data.result) {
				this.$toast.success('Saved successfully');
				this.$emit('updateShipToAddr');
			} else {
				this.$toast.error(data.msg);
			}
		},
		notify() {
			this.$toast.info("Click 'Save & Close' to save the changes.");
		},
	},
	created() {
		if (!this.prev_ship_to_address_list) this.loadShipToAddressHistory();
		else this.prev_ship_to_address_list_for_update = _.cloneDeep(this.prev_ship_to_address_list);
	},
};
</script>

<style></style>
